import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { SearchPage } from './features/search';
import { ProfileDetailsPage } from './features/profiles';
import { ShortlistSubmittedPage } from './features/shortlist';
import { AdminPage } from './features/campaigns';
import { Header } from './shared/components/Header';
import { Footer } from './shared/components/Footer';
import ProtectedRoute from './shared/components/ProtectedRoute';
import { ShortlistProvider } from './contexts/ShortlistContext';
import GlobalShortlist from './components/GlobalShortlist';
import './App.css';

function App() {
  return (
    <ShortlistProvider>
      <Router>
        <div
          className="App min-h-screen flex flex-col"
          style={{
            fontFamily: 'var(--dreamdev-font-family)',
            background: 'var(--dreamdev-bg-primary)',
            color: 'var(--dreamdev-text-primary)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}
        >
          <Header />

          <main className="flex-1 w-full flex flex-col items-center">
            <Routes>
              <Route path="/" element={<SearchPage />} />
              <Route path=":shortUrl" element={<SearchPage />} />
              <Route path="/profiles/:id" element={<ProfileDetailsPage />} />
              <Route path="/shortlists/:id" element={<ShortlistSubmittedPage />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminPage />
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<SearchPage />} />
            </Routes>
          </main>

          <Footer />

          {/* Global Shortlist Components */}
          <GlobalShortlist />
        </div>
      </Router>
    </ShortlistProvider>
  );
}

export default App;
